// libs
import { createContext, useContext } from 'react';

// defs
interface IWishlistContext {
  page: number;
  incrementPage: () => void;
  isFetching: boolean;
  isRemoving: boolean;
  isError: boolean;
  errorStatusCode: string;
  setIsRemoving: (value: boolean) => void;
  removeProductFromWishlist: Function;
  fetchProduct: (productId: string) => void;
  addToCart: (product: Listing.IProduct | undefined) => void;
  firstName: string;
  showPrice: boolean;
  showActionButton: boolean;
  wishlistName: string;
  isUserFetching: boolean;
  initialAPICalled: boolean;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: IWishlistContext = {
  page: 1,
  incrementPage: EMPTY_FUNC,
  isFetching: true,
  isRemoving: false,
  isError: false,
  errorStatusCode: '',
  firstName: '',
  showPrice: true,
  showActionButton: true,
  wishlistName: 'Wishlist',
  isUserFetching: false,
  setIsRemoving: EMPTY_FUNC,
  removeProductFromWishlist: EMPTY_FUNC,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fetchProduct: (productId: string) => {},
  addToCart: EMPTY_FUNC,
  initialAPICalled: false,
};

const wishlistContext = createContext(initialValue);

export const useWishlistContext = () => useContext(wishlistContext);

export default wishlistContext;
